<template>
    <button @click="topFunction()" id="to-top-button" title="Go to top">
        <i class="fas fa-angle-up" style="font-size: 1.7em;"></i><br/>
        <span style="font-size: 0.8em;">Back to</span><br/>   
        <span style="font-size: 0.8em;">Top</span>     
    </button>
</template>
<script>
import { smoothScrollTo } from '@/util/smoothScroll.js'
export default {
    name: 'backtotop',
    mounted () {
        window.addEventListener('scroll', this.scrollFunction);
    },
    beforeDestroy () {
        window.removeEventListener('scroll', this.scrollFunction)
    },
    methods: {
        scrollFunction() {
            if (document.body.scrollTop > 600 || document.documentElement.scrollTop > 600) {
                document.getElementById("to-top-button").style.display = "block";
            } else {
                document.getElementById("to-top-button").style.display = "none";
            }
        },
        topFunction () {
            smoothScrollTo(window, document.body || document.documentElement, 0, 500)
        }
    }
}
</script>



